import React from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';
import { getCookie } from 'utils/cookie';
import { setAuthorization } from 'utils/axiosClient';
import { useOfflineToast } from 'hooks/useOfflineToast';
import useCheckVersion from 'hooks/useCheckVersion';
import { ToastContainer } from 'react-toastify';
import ReactGA from "react-ga4"
import { GA_MEASUREMENT_ID } from 'constants/global';
const token = getCookie('hubAuthToken');
if(token){
  setAuthorization(token);
}
function App() {

  useCheckVersion();

  useOfflineToast();

  if (process.env.REACT_APP_ENV === 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID)
  }

  return (
    <React.Fragment>
      <Route />
      <ToastContainer position='bottom-center' theme='colored' autoClose={2000} />
    </React.Fragment>
  );
}

export default App;
